module.exports = __webpack_public_path__ + "4035bd462f7ac764e05945e2c2f946c9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/policy/picmobile13.png
// module id = 1873
// module chunks = 0